import { Self } from "./Self";
import { Free } from "./Free";

export function DosageInformation({ medicineProps }) {
  if (medicineProps.fillStyle === "self") return <Self {...medicineProps} />;
  if (medicineProps.fillStyle === "free") return <Free {...medicineProps} />;
}
